import { render, staticRenderFns } from "./unit_comp_app.vue?vue&type=template&id=fece67f6"
import script from "./unit_comp_app.vue?vue&type=script&lang=js"
export * from "./unit_comp_app.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports